<template>
  <div>
    <p class="text-white font-semibold">When did you purchase your policy?</p>
    <tw-select additional-class="quote-input-select" :items="options" @updated="optionChanged"></tw-select>

    <div v-if="selected">


      <div class="row mt-6">
        <div class="small-12 columns">
          <div><span class="font-semibold">Email: </span>{{ details.email }}
          </div>
          <div><span class="font-semibold">Telephone:
            </span>{{ details.phone }}</div>
        </div>
      </div>
      
    </div>

  </div>
</template>

<script>
export default {
  name: "ClaimsFormModal",
  props: [
    "whEmail",
    "whPhone",
    "liveDate",
    "claimsTel",
    "claimsEmail",
    "enquiryEmail",
    "enquiryPhone",
  ],
  data() {
    return {
      preCovid: null,
      valueSelected: false,
      downloadLink: null,
      selected: null,
    };
  },
  computed: {
    details() {
      return this.options.find(o => o.id === this.selected);
    },
    options() {
      let opts = [];

      opts.push({
        id: "option-1",
        name: "Please Select",
      });

      opts.push({
        id: "option-2",
        name: "Policies purchased on or before 31st December 2024",
        phone: '0344 856 7497',
        email: 'claims@protectmybike.co.uk',
      });

      opts.push({
        id: "option-3",
        name: "Policies purchased on or after 1st January 2025",
        phone: '0345 030 8110',
        email: 'claims@protectmybike.co.uk',
      });

      return opts;
    },
  },
  methods: {
    optionChanged(e) {
      this.selected = e.id;
    },
  },
};
</script>
